module.exports = __webpack_public_path__ + "static/media/img_phone-dark-full.45919c62.png";